import {
  motion,
  useAnimationFrame,
  useMotionValue,
  useScroll,
  useSpring,
  useTransform,
} from "framer-motion";

export default function FlyingApple({ started, pedestalRef }) {
  const { scrollYProgress } = useScroll();
  const w0 = typeof window !== "undefined" ? window.innerWidth : 1200;
  const h0 = typeof window !== "undefined" ? window.innerHeight : 800;
  const SIZE = Math.round(Math.min(Math.max(w0 * 0.0585, 31), 126));
  const x = useMotionValue(w0 * 0.88);
  const y = useMotionValue(h0 + 140);
  const sx = useSpring(x, { stiffness: 55, damping: 16, mass: 0.7 });
  const sy = useSpring(y, { stiffness: 55, damping: 16, mass: 0.7 });
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 480]);

  useAnimationFrame(() => {
    if (!started) return;
    const w = window.innerWidth;
    const h = window.innerHeight;
    const ped = pedestalRef?.current;
    if (ped) {
      const r = ped.getBoundingClientRect();
      if (r.top < h * 0.92) {
        x.set(r.left + r.width / 2 - SIZE / 2);
        y.set(r.top - SIZE + 8);
        return;
      }
    }
    const p = scrollYProgress.get();
    const sway = Math.sin(p * Math.PI * 3) * Math.min(w * 0.06, 70);
    x.set(w * (w < 768 ? 0.76 : 0.82) + sway - SIZE / 2);
    y.set(h * 0.16 + Math.min(p * 1.15, 1) * h * 0.5);
  });

  if (!started) return null;

  return (
    <motion.div
      data-testid="flying-apple"
      className="pointer-events-none fixed left-0 top-0 z-30"
      style={{ x: sx, y: sy, width: SIZE, height: SIZE }}
    >
      <div className="halo absolute -inset-3 rounded-full" />
      <motion.img
        src="/apple.png"
        alt=""
        style={{ rotate }}
        className="h-full w-full drop-shadow-[0_14px_24px_rgba(15,23,42,0.28)]"
      />
    </motion.div>
  );
}
